import { hasConsent } from '@/lib/cookieConsent';

const WIDGET_SCRIPT_ID = 'it-chat-widget-script';
let widgetLoaded = false;

const WIDGET_ATTRS: Record<string, string> = {
  'data-api-base': 'https://api.interactivetalker.com',
  'data-integration': '89948711-c9ab-4de5-8611-9947d8c1ea87',
  'data-site-key': 'CrY9lVU7oAK3zsc94UxaR1LH9E7uSeDLVFq82f5jBkU',
  'data-chat-title': 'Interactive Talker',
  'data-accent': '#0ea5e9',
  'data-panel-bg': '#ffffff',
  'data-messages-bg': '#f8fafc',
};

export function loadChatWidget(): void {
  if (widgetLoaded || !hasConsent('functional')) return;
  if (document.getElementById(WIDGET_SCRIPT_ID)) {
    widgetLoaded = true;
    return;
  }

  const script = document.createElement('script');
  script.id = WIDGET_SCRIPT_ID;
  script.src = '/widget/embed.js';
  script.async = true;
  for (const [key, value] of Object.entries(WIDGET_ATTRS)) {
    script.setAttribute(key, value);
  }
  document.body.appendChild(script);
  widgetLoaded = true;
}

export function unloadChatWidget(): void {
  const script = document.getElementById(WIDGET_SCRIPT_ID);
  script?.remove();
  document.querySelectorAll('[data-it-widget-root]').forEach((el) => el.remove());
  document.querySelectorAll('[data-va-chat]').forEach((el) => el.remove());
  document.querySelectorAll('.it-widget-launcher, .it-widget-panel, .va-chat-launcher').forEach((el) => el.remove());
  widgetLoaded = false;
}
